// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__PGNIZ","selected":"Chip_selected__4tnMY"};